<template>
  <div class="lead-form-dialog-container">
    <q-dialog
      :ref="modalRef"
      v-cloak
      class="--fullscreen-height__padded"
      :full-width="windowWidth <= 1025"
      :position="windowWidth <= 1025 ? 'bottom' : 'standard'"
    >
      <q-card class="bg-background-light" style="width: 100%; max-width: 600px">
        <DialogHeader header="Check Availability" header-icon="sym_r_forum" />

        <div>
          <q-card-section class="q-pb-none">
            <div class="row items-center justify-start no-wrap">
              <q-img
                :src="vehicle.images[0]"
                spinner-color="white"
                transition="fade"
                :ratio="4 / 3"
                fit="contain"
                style="width: 160px; height: auto; background: #000;border-radius: 12px"
                loading="lazy"
              >
                <template v-slot:error>
                  <q-img
                    src="https://d2z3ffoe99vnx9.cloudfront.net/vehicle_images/no_image_available.jpeg"
                    spinner-color="white"
                    transition="fade"
                    :ratio="ratio"
                    fit="contain"
                    style="width: 100%; height: auto; background: #f2f2f2;"
                    loading="lazy"
                  />
                </template>
              </q-img>
              <div
                style="width: calc(100% - 160px)"
                class="q-ml-md column items-start justify-between"
              >
                <div class="q-mb-sm full-width">
                  <h5
                    v-html="vehicle.title"
                    class="--no-style ellipsis q-ma-none"
                  />
                  <div class="flex items-center text-text-light ellipsis">
                    <p class="q-ma-none">
                      {{ vehicle.trim }}
                    </p>
                    <span class="q-mx-xs">&#8226;</span>
                    <span
                      v-html="vehicle.mileage_formatted + ' miles'"
                      class="ellipsis"
                    />
                  </div>
                </div>

                <div class="flex items-center q-mb-sm">
                  <h3 class="text-weight-bold ellipsis q-mb-none">
                    {{ vehicle.price_formatted }}
                  </h3>
                  <PriceDropLabel
                    v-if="
                      vehicle.tags.filter(tag => tag.tag === 'Price Drop')
                        .length > 0
                    "
                    :amount-change="
                      vehicle.tags.filter(tag => tag.tag === 'Price Drop')[0]
                        .metadata.amount_change
                    "
                    class="q-ml-sm"
                  />
                </div>
              </div>
            </div>
          </q-card-section>

          <q-separator inset class="q-mt-md" />

          <q-card-section class="q-pt-sm q-mt-xs q-pb-none">
            <div>
              <p class="q-ma-none text-weight-bold">
                {{ vehicle.dealer.name }}
              </p>
              <p class="q-ma-none text-text-light --text-sm">
                {{ vehicle.dealer.address }}
              </p>
              <p class="q-ma-none text-text-light --text-sm">
                {{ vehicle.dealer.city }}, {{ vehicle.dealer.state }}
                {{ vehicle.dealer.postal_code }}
              </p>
            </div>
            <div v-if="'distance' in vehicle" class="flex items-center q-mt-xs">
              <q-icon name="sym_r_place" class="q-mr-xs" size="13px" />
              <p class="ellipsis --text-sm text-weight-medium">
                {{ vehicle.distance + " miles away" }}
              </p>
            </div>
          </q-card-section>
        </div>

        <q-separator inset style="margin-top: 12px" />

        <div style="width: 100%">
          <q-card-section
            :class="{
              'q-py-xl': leadSubmitted
            }"
          >
            <component
              v-bind:is="'jfpc-vehicle-lead-form'"
              publisher-account-id="10001"
              component-placement="Listing"
              component-theme="carscience"
              dark-mode
              :channel-one="
                urlParams().get('utm_campaign')
                  ? urlParams().get('utm_campaign')
                  : ''
              "
              :product-id="vehicle.product_id"
              @submitted="leadSubmitted = true"
              carscience-disclaimer
            />
          </q-card-section>
        </div>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import DialogHeader from "@/components/UI/DialogHeader.vue";
import PriceDropLabel from "@/components/UI/PriceDropLabel.vue";

export default {
  name: "LeadFormDialog",
  components: { PriceDropLabel, DialogHeader },
  props: {
    vehicle: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      modalRef: "leadFormDialog",
      lead: {
        first_name: "",
        last_name: "",
        email: "",
        phone: "",
        postal_code: this.$store.state.search.location.postalCode
          ? this.$store.state.search.location.postalCode
          : ""
      },
      disableSubmit: false,
      leadSubmitted: false
    };
  },
  computed: {},
  mounted() {},
  methods: {
    show() {
      this.$refs[this.modalRef].show();
    },
    hide() {
      this.$refs[this.modalRef].hide();
    }
  }
};
</script>

<style lang="scss" scoped></style>
